import { HDS_COLOR_TEXT_DEFAULT, HDS_COLOR_TEXT_SUBTLE, HDS_COLOR_TEXT_NONESSENTIAL, HDS_COLOR_TEXT_DISABLED, HDS_COLOR_TEXT_INVERSE, HDS_COLOR_TEXT_DANGER, HDS_COLOR_TEXT_SUCCESS, HDS_FONT_WEIGHT_BODY_DEFAULT, HDS_FONT_WEIGHT_BODY_BOLD, HDS_FONT_WEIGHT_DISPLAY_LIGHT, HDS_FONT_WEIGHT_DISPLAY_MEDIUM, HDS_FONT_WEIGHT_DISPLAY_DEFAULT, HDS_FONT_WEIGHT_DISPLAY_BOLD, HDS_FONT_WEIGHT_CODE_DEFAULT, HDS_LINE_HEIGHT_BODY_DEFAULT, HDS_LINE_HEIGHT_BODY_TIGHT, HDS_LINE_HEIGHT_DISPLAY, HDS_LINE_HEIGHT_CODE, HDS_TYPE_SCALE_BODY_SMALL, HDS_TYPE_SCALE_BODY_DEFAULT, HDS_TYPE_SCALE_BODY_LARGE, HDS_TYPE_SCALE_DISPLAY_HEADING1, HDS_TYPE_SCALE_DISPLAY_HEADING2, HDS_TYPE_SCALE_DISPLAY_HEADING3, HDS_TYPE_SCALE_DISPLAY_HEADING4, HDS_TYPE_SCALE_DISPLAY_HEADING5, HDS_TYPE_SCALE_DISPLAY_HEADING6, HDS_TYPE_SCALE_CODE_DEFAULT, HDS_TEXT_BODY, HDS_TEXT_BODY_SMALL, HDS_TEXT_BODY_LARGE, HDS_TEXT_CODE, HDS_DISPLAY_HEADING1, HDS_DISPLAY_HEADING2, HDS_DISPLAY_HEADING3, HDS_DISPLAY_HEADING4, HDS_DISPLAY_HEADING5, HDS_DISPLAY_HEADING6, HDS_DISPLAY_TAGLINE, HDS_DISPLAY_PAGE_HEADING, HDS_ALERT_COLOR_BACKGROUND_DANGER, HDS_ALERT_COLOR_BACKGROUND_INFO, HDS_ALERT_COLOR_BACKGROUND_WARNING, HDS_ALERT_COLOR_BACKGROUND_SUCCESS, HDS_ALERT_COLOR_BACKGROUND_TIP, HDS_ALERT_COLOR_BACKGROUND_DANGER_LOUD, HDS_ALERT_COLOR_BACKGROUND_INFO_LOUD, HDS_ALERT_COLOR_BACKGROUND_WARNING_LOUD, HDS_CONTAINER_RADIUS_BORDER, HDS_CARD_SHADOW, HDS_BORDER_SUBTLE, HDS_CONTAINER_COLOR_BACKGROUND, HDS_ALERT_BORDER_DANGER, HDS_ALERT_BORDER_INFO, HDS_ALERT_BORDER_WARNING, HDS_ALERT_BORDER_SUCCESS, HDS_ALERT_BORDER_TIP, HDS_BUTTON_COLOR_BACKGROUND_PRIMARY_IDLE, HDS_BUTTON_COLOR_BACKGROUND_PRIMARY_HOVER, HDS_BUTTON_COLOR_BACKGROUND_PRIMARY_PRESSED, HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DEFAULT_IDLE, HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DEFAULT_HOVER, HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DEFAULT_PRESSED, HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DARK_IDLE, HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DARK_HOVER, HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DARK_PRESSED, HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_LIGHT_IDLE, HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_LIGHT_HOVER, HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_LIGHT_PRESSED, HDS_BUTTON_COLOR_BACKGROUND_SECONDARY_IDLE, HDS_BUTTON_COLOR_BACKGROUND_SECONDARY_HOVER, HDS_BUTTON_COLOR_BACKGROUND_SECONDARY_PRESSED, HDS_BUTTON_COLOR_BACKGROUND_DANGER_IDLE, HDS_BUTTON_COLOR_BACKGROUND_DANGER_HOVER, HDS_BUTTON_COLOR_BACKGROUND_DANGER_PRESSED, HDS_BUTTON_COLOR_BACKGROUND_WHITE_IDLE, HDS_BUTTON_COLOR_BACKGROUND_WHITE_HOVER, HDS_BUTTON_COLOR_BACKGROUND_WHITE_PRESSED, HDS_BUTTON_COLOR_BACKGROUND_GHOST_IDLE, HDS_BUTTON_COLOR_BACKGROUND_GHOST_HOVER, HDS_BUTTON_COLOR_BACKGROUND_GHOST_PRESSED, HDS_BUTTON_COLOR_BACKGROUND_DISABLED, HDS_BUTTON_COLOR_BACKGROUND_TRANSPARENT, HDS_BUTTON_COLOR_BORDER_PRIMARY_IDLE, HDS_BUTTON_COLOR_BORDER_PRIMARY_HOVER, HDS_BUTTON_COLOR_BORDER_PRIMARY_PRESSED, HDS_BUTTON_COLOR_BORDER_NEUTRAL_DEFAULT_IDLE, HDS_BUTTON_COLOR_BORDER_NEUTRAL_DEFAULT_HOVER, HDS_BUTTON_COLOR_BORDER_NEUTRAL_DEFAULT_PRESSED, HDS_BUTTON_COLOR_BORDER_NEUTRAL_DARK_IDLE, HDS_BUTTON_COLOR_BORDER_NEUTRAL_DARK_HOVER, HDS_BUTTON_COLOR_BORDER_NEUTRAL_DARK_PRESSED, HDS_BUTTON_COLOR_BORDER_NEUTRAL_LIGHT_IDLE, HDS_BUTTON_COLOR_BORDER_NEUTRAL_LIGHT_HOVER, HDS_BUTTON_COLOR_BORDER_NEUTRAL_LIGHT_PRESSED, HDS_BUTTON_COLOR_BORDER_SECONDARY_IDLE, HDS_BUTTON_COLOR_BORDER_SECONDARY_HOVER, HDS_BUTTON_COLOR_BORDER_SECONDARY_PRESSED, HDS_BUTTON_COLOR_BORDER_DANGER_IDLE, HDS_BUTTON_COLOR_BORDER_DANGER_HOVER, HDS_BUTTON_COLOR_BORDER_DANGER_PRESSED, HDS_BUTTON_COLOR_BORDER_TRANSPARENT, HDS_BUTTON_COLOR_BORDER_DISABLED, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_PRIMARY_DEFAULT, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_NEUTRAL_DEFAULT, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_NEUTRAL_DARK, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_NEUTRAL_LIGHT, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_SECONDARY_DEFAULT, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_DANGER_DEFAULT, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_TRANSPARENT_IDLE, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_TRANSPARENT_HOVER, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_TRANSPARENT_PRESSED, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_WHITE_DEFAULT, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_GHOST_DEFAULT, HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_DISABLED, HDS_BUTTON_RADIUS_DEFAULT, HDS_BUTTON_WIDTH_BORDER_DEFAULT, HDS_BUTTON_TYPOGRAPHY_DEFAULT, HDS_ACTION_COLOR_TEXT_DEFAULT_IDLE, HDS_ACTION_COLOR_TEXT_DEFAULT_HOVER, HDS_ACTION_COLOR_TEXT_DEFAULT_PRESSED, HDS_ACTION_COLOR_TEXT_DEFAULT_VISITED, HDS_ACTION_COLOR_TEXT_VISITED, HDS_ACTION_COLOR_TEXT_DISABLED, HDS_ACTION_COLOR_TEXT_DANGER_IDLE, HDS_ACTION_COLOR_TEXT_DANGER_HOVER, HDS_ACTION_COLOR_TEXT_DANGER_PRESSED, HDS_ACTION_COLOR_TEXT_DANGER_VISITED, HDS_ACTION_COLOR_TEXT_ON_SURFACE_IDLE, HDS_ACTION_COLOR_TEXT_ON_SURFACE_HOVER, HDS_ACTION_COLOR_TEXT_ON_SURFACE_PRESSED, HDS_ACTION_COLOR_TEXT_ON_SURFACE_VISITED, HDS_ACTION_COLOR_TEXT_INVERSE_IDLE, HDS_ACTION_COLOR_TEXT_INVERSE_HOVER, HDS_ACTION_COLOR_TEXT_INVERSE_PRESSED, HDS_ACTION_COLOR_TEXT_INVERSE_VISITED, HDS_ACTION_TYPOGRAPHY_DEFAULT, HDS_ALERT_TEXT } from 'hds-tokens';
import { HDS_FONT_FAMILY_DEFAULT, HDS_FONT_FAMILY_CODE } from 'hds-tokens/web-tokens/base-tokens';
import { HDS_SPACE_NONE, HDS_SPACE_50, HDS_SPACE_100, HDS_SPACE_150, HDS_SPACE_200, HDS_SPACE_250, HDS_SPACE_300, HDS_SPACE_350, HDS_SPACE_400, HDS_SPACE_450, HDS_SPACE_500, HDS_SPACE_600, HDS_SPACE_700, HDS_SPACE_800, HDS_SPACE_900, HDS_SPACE_1000, HDS_SPACE_1100, HDS_SPACE_1200, HDS_SPACE_1300, HDS_SPACE_1400, HDS_SPACE_1500 } from 'hds-tokens/web-tokens/semantic-tokens';
export const DEFAULT_THEME = {
  UNSTABLE_HDS: {
    HDS_COLOR_TEXT_DEFAULT,
    HDS_COLOR_TEXT_SUBTLE,
    HDS_COLOR_TEXT_NONESSENTIAL,
    HDS_COLOR_TEXT_DISABLED,
    HDS_COLOR_TEXT_INVERSE,
    HDS_COLOR_TEXT_DANGER,
    HDS_COLOR_TEXT_SUCCESS,
    HDS_FONT_WEIGHT_BODY_DEFAULT,
    HDS_FONT_WEIGHT_BODY_BOLD,
    HDS_FONT_WEIGHT_DISPLAY_LIGHT,
    HDS_FONT_WEIGHT_DISPLAY_MEDIUM,
    HDS_FONT_WEIGHT_DISPLAY_DEFAULT,
    HDS_FONT_WEIGHT_DISPLAY_BOLD,
    HDS_FONT_WEIGHT_CODE_DEFAULT,
    HDS_LINE_HEIGHT_BODY_DEFAULT,
    HDS_LINE_HEIGHT_BODY_TIGHT,
    HDS_LINE_HEIGHT_DISPLAY,
    HDS_LINE_HEIGHT_CODE,
    HDS_TYPE_SCALE_BODY_SMALL,
    HDS_TYPE_SCALE_BODY_DEFAULT,
    HDS_TYPE_SCALE_BODY_LARGE,
    HDS_TYPE_SCALE_DISPLAY_HEADING1,
    HDS_TYPE_SCALE_DISPLAY_HEADING2,
    HDS_TYPE_SCALE_DISPLAY_HEADING3,
    HDS_TYPE_SCALE_DISPLAY_HEADING4,
    HDS_TYPE_SCALE_DISPLAY_HEADING5,
    HDS_TYPE_SCALE_DISPLAY_HEADING6,
    HDS_TYPE_SCALE_CODE_DEFAULT,
    HDS_TEXT_BODY,
    HDS_TEXT_BODY_LARGE,
    HDS_TEXT_BODY_SMALL,
    HDS_TEXT_CODE,
    HDS_DISPLAY_HEADING1,
    HDS_DISPLAY_HEADING2,
    HDS_DISPLAY_HEADING3,
    HDS_DISPLAY_HEADING4,
    HDS_DISPLAY_HEADING5,
    HDS_DISPLAY_HEADING6,
    HDS_DISPLAY_TAGLINE,
    HDS_DISPLAY_PAGE_HEADING,
    HDS_FONT_FAMILY_DEFAULT,
    HDS_FONT_FAMILY_CODE,
    HDS_SPACE_NONE,
    HDS_SPACE_50,
    HDS_SPACE_100,
    HDS_SPACE_150,
    HDS_SPACE_200,
    HDS_SPACE_250,
    HDS_SPACE_300,
    HDS_SPACE_350,
    HDS_SPACE_400,
    HDS_SPACE_450,
    HDS_SPACE_500,
    HDS_SPACE_600,
    HDS_SPACE_700,
    HDS_SPACE_800,
    HDS_SPACE_900,
    HDS_SPACE_1000,
    HDS_SPACE_1100,
    HDS_SPACE_1200,
    HDS_SPACE_1300,
    HDS_SPACE_1400,
    HDS_SPACE_1500,
    HDS_ALERT_COLOR_BACKGROUND_DANGER,
    HDS_ALERT_COLOR_BACKGROUND_INFO,
    HDS_ALERT_COLOR_BACKGROUND_WARNING,
    HDS_ALERT_COLOR_BACKGROUND_SUCCESS,
    HDS_ALERT_COLOR_BACKGROUND_TIP,
    HDS_ALERT_COLOR_BACKGROUND_DANGER_LOUD,
    HDS_ALERT_COLOR_BACKGROUND_INFO_LOUD,
    HDS_ALERT_COLOR_BACKGROUND_WARNING_LOUD,
    HDS_CONTAINER_RADIUS_BORDER,
    HDS_CARD_SHADOW,
    HDS_BORDER_SUBTLE,
    HDS_CONTAINER_COLOR_BACKGROUND,
    HDS_ALERT_BORDER_DANGER,
    HDS_ALERT_BORDER_INFO,
    HDS_ALERT_BORDER_WARNING,
    HDS_ALERT_BORDER_SUCCESS,
    HDS_ALERT_BORDER_TIP,
    HDS_BUTTON_COLOR_BACKGROUND_PRIMARY_IDLE,
    HDS_BUTTON_COLOR_BACKGROUND_PRIMARY_HOVER,
    HDS_BUTTON_COLOR_BACKGROUND_PRIMARY_PRESSED,
    HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DEFAULT_IDLE,
    HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DEFAULT_HOVER,
    HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DEFAULT_PRESSED,
    HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DARK_IDLE,
    HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DARK_HOVER,
    HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_DARK_PRESSED,
    HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_LIGHT_IDLE,
    HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_LIGHT_HOVER,
    HDS_BUTTON_COLOR_BACKGROUND_NEUTRAL_LIGHT_PRESSED,
    HDS_BUTTON_COLOR_BACKGROUND_SECONDARY_IDLE,
    HDS_BUTTON_COLOR_BACKGROUND_SECONDARY_HOVER,
    HDS_BUTTON_COLOR_BACKGROUND_SECONDARY_PRESSED,
    HDS_BUTTON_COLOR_BACKGROUND_DANGER_IDLE,
    HDS_BUTTON_COLOR_BACKGROUND_DANGER_HOVER,
    HDS_BUTTON_COLOR_BACKGROUND_DANGER_PRESSED,
    HDS_BUTTON_COLOR_BACKGROUND_WHITE_IDLE,
    HDS_BUTTON_COLOR_BACKGROUND_WHITE_HOVER,
    HDS_BUTTON_COLOR_BACKGROUND_WHITE_PRESSED,
    HDS_BUTTON_COLOR_BACKGROUND_GHOST_IDLE,
    HDS_BUTTON_COLOR_BACKGROUND_GHOST_HOVER,
    HDS_BUTTON_COLOR_BACKGROUND_GHOST_PRESSED,
    HDS_BUTTON_COLOR_BACKGROUND_DISABLED,
    HDS_BUTTON_COLOR_BACKGROUND_TRANSPARENT,
    HDS_BUTTON_COLOR_BORDER_PRIMARY_IDLE,
    HDS_BUTTON_COLOR_BORDER_PRIMARY_HOVER,
    HDS_BUTTON_COLOR_BORDER_PRIMARY_PRESSED,
    HDS_BUTTON_COLOR_BORDER_NEUTRAL_DEFAULT_IDLE,
    HDS_BUTTON_COLOR_BORDER_NEUTRAL_DEFAULT_HOVER,
    HDS_BUTTON_COLOR_BORDER_NEUTRAL_DEFAULT_PRESSED,
    HDS_BUTTON_COLOR_BORDER_NEUTRAL_DARK_IDLE,
    HDS_BUTTON_COLOR_BORDER_NEUTRAL_DARK_HOVER,
    HDS_BUTTON_COLOR_BORDER_NEUTRAL_DARK_PRESSED,
    HDS_BUTTON_COLOR_BORDER_NEUTRAL_LIGHT_IDLE,
    HDS_BUTTON_COLOR_BORDER_NEUTRAL_LIGHT_HOVER,
    HDS_BUTTON_COLOR_BORDER_NEUTRAL_LIGHT_PRESSED,
    HDS_BUTTON_COLOR_BORDER_SECONDARY_IDLE,
    HDS_BUTTON_COLOR_BORDER_SECONDARY_HOVER,
    HDS_BUTTON_COLOR_BORDER_SECONDARY_PRESSED,
    HDS_BUTTON_COLOR_BORDER_DANGER_IDLE,
    HDS_BUTTON_COLOR_BORDER_DANGER_HOVER,
    HDS_BUTTON_COLOR_BORDER_DANGER_PRESSED,
    HDS_BUTTON_COLOR_BORDER_TRANSPARENT,
    HDS_BUTTON_COLOR_BORDER_DISABLED,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_PRIMARY_DEFAULT,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_NEUTRAL_DEFAULT,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_NEUTRAL_DARK,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_NEUTRAL_LIGHT,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_SECONDARY_DEFAULT,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_DANGER_DEFAULT,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_TRANSPARENT_IDLE,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_TRANSPARENT_HOVER,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_TRANSPARENT_PRESSED,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_WHITE_DEFAULT,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_GHOST_DEFAULT,
    HDS_BUTTON_COLOR_TEXT_ON_BACKGROUND_DISABLED,
    HDS_BUTTON_RADIUS_DEFAULT,
    HDS_BUTTON_WIDTH_BORDER_DEFAULT,
    HDS_BUTTON_TYPOGRAPHY_DEFAULT,
    HDS_ACTION_COLOR_TEXT_DEFAULT_IDLE,
    HDS_ACTION_COLOR_TEXT_DEFAULT_HOVER,
    HDS_ACTION_COLOR_TEXT_DEFAULT_PRESSED,
    HDS_ACTION_COLOR_TEXT_DEFAULT_VISITED,
    HDS_ACTION_COLOR_TEXT_VISITED,
    HDS_ACTION_COLOR_TEXT_DISABLED,
    HDS_ACTION_COLOR_TEXT_DANGER_IDLE,
    HDS_ACTION_COLOR_TEXT_DANGER_HOVER,
    HDS_ACTION_COLOR_TEXT_DANGER_PRESSED,
    HDS_ACTION_COLOR_TEXT_DANGER_VISITED,
    HDS_ACTION_COLOR_TEXT_ON_SURFACE_IDLE,
    HDS_ACTION_COLOR_TEXT_ON_SURFACE_HOVER,
    HDS_ACTION_COLOR_TEXT_ON_SURFACE_PRESSED,
    HDS_ACTION_COLOR_TEXT_ON_SURFACE_VISITED,
    HDS_ACTION_COLOR_TEXT_INVERSE_IDLE,
    HDS_ACTION_COLOR_TEXT_INVERSE_HOVER,
    HDS_ACTION_COLOR_TEXT_INVERSE_PRESSED,
    HDS_ACTION_COLOR_TEXT_INVERSE_VISITED,
    HDS_ACTION_TYPOGRAPHY_DEFAULT,
    HDS_ALERT_TEXT
  }
};